import { CatalogueDataType, ProductStatus } from 'src/lib/types/common/catalogue'

export enum ProductSelectorViewMode {
  SELECT = 'SELECT',
  EXCLUDE = 'EXCLUDE'
}

export interface ProductSearchDialogProps {
  catalogueType: 'COLLECTION' | 'PRODUCT' | 'VARIANT' | 'PRODUCT_AND_VARIANT'
  openHandler: {
    open: boolean
    onOpenChange: (open: boolean) => void
  }
  products: {
    initialSelectedProducts?: CatalogueDataType[]
    initialExcludedProducts?: CatalogueDataType[]
  }
  actionHandler: {
    onApply: (selectedProducts: CatalogueDataType[], excludedProducts?: CatalogueDataType[]) => void
  }
  viewModeHandler: {
    defaultViewMode?: ProductSelectorViewMode
    showExclusionOption?: boolean
    showAllOption?: boolean
  }
  /**
   * Product statuses to leave out of the list entirely. The catalogue endpoint
   * has no status filter, so this is applied to the fetched pages: a page made
   * up only of excluded products renders nothing and the next page is fetched.
   * Subscriptions use this to keep draft products out.
   */
  excludedStatuses?: ProductStatus[]
  /**
   * Variants that cannot be picked, with the reason surfaced as a tooltip.
   * Used by subscriptions, where a variant may only belong to one subscription.
   */
  disabledVariants?: {
    ids: Set<string>
    /** Tooltip on a disabled variant row. */
    reason: string
    /** Inline label when every variant of a product is disabled. */
    label?: string
  }
  singleSelect?: boolean
  /**
   * Whether Shopify bundle products may appear in search results. Defaults to
   * true (existing behaviour); Quick Add-On sets this to false since a bundle
   * cannot be attached as an add-on.
   */
  includeBundleProducts?: boolean
}
